<template>
    <div class="tsa-loadingV2" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <span class="el-icon-loading"></span>
            <p>{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            message: '',
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-loadingV2 {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            // background: rgba(0, 0, 0, .5);
            z-index: 1;
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
            text-align: center;
            color: #2468F2;
            .el-icon-loading {
                font-size: 18px;
                display: block;
                margin-bottom: 4px;
            }
            p {
                font-size: 14px;
            }
        }
    }
</style>